import { useEffect, useRef } from "react";
import "./Welcome.css";
import { useNavigate } from "react-router-dom";

const HEADLINE = ["FLYTUTOR", "TECHNOLOGIES"];
const TAGLINE_WORDS = [
  "DGCA-approved", "drone", "pilot", "training", "&",
  "next-generation", "UAV", "mastery"
];

export default function Welcome() {
  const navigate = useNavigate();
  const lettersRef = useRef([]);
  const labelRef = useRef(null);
  const taglineRef = useRef(null);
  const ctaRef = useRef(null);
  const scrollRef = useRef(null);

  useEffect(() => {
    const LINE1_START = 0.45;
    const LINE2_START = 1.05;
    const STAGGER = 0.048;

    let totalLetterIdx = 0;
    HEADLINE.forEach((word, wi) => {
      const lineStart = wi === 0 ? LINE1_START : LINE2_START;
      word.split("").forEach((_, li) => {
        const el = lettersRef.current[totalLetterIdx];
        if (el) {
          el.style.animationDelay = `${lineStart + li * STAGGER}s`;
        }
        totalLetterIdx++;
      });
    });

    if (taglineRef.current) {
      const words = taglineRef.current.querySelectorAll(".wt-word");
      words.forEach((w, i) => {
        w.style.animationDelay = `${1.85 + i * 0.07}s`;
      });
    }

    if (ctaRef.current) ctaRef.current.style.animationDelay = "2.55s";
    if (scrollRef.current) scrollRef.current.style.animationDelay = "2.9s";
  }, []);

  let globalIdx = 0;

  return (
    <section className="wt-wrap">

      {/* Label */}
      <div ref={labelRef} className="wt-label">
        <span className="wt-label-line" />
        <span className="wt-label-text">Welcome to</span>
        <span className="wt-label-line" />
      </div>

      {/* Headline */}
      <h1 className="wt-headline" aria-label={HEADLINE.join(" ")}>
        {HEADLINE.map((word, wi) => (
          <div key={wi} className="wt-line">
            {word.split("").map((char) => {
              const idx = globalIdx++;
              return (
                <span
                  key={idx}
                  ref={(el) => { lettersRef.current[idx] = el; }}
                  className="wt-char"
                >
                  {char}
                </span>
              );
            })}
          </div>
        ))}
      </h1>

      {/* Tagline */}
      <p ref={taglineRef} className="wt-tagline">
        {TAGLINE_WORDS.map((word, i) => (
          <span key={i} className="wt-word">
            {word}{i < TAGLINE_WORDS.length - 1 ? "\u00a0" : ""}
          </span>
        ))}
      </p>

      {/* CTA */}
      <div ref={ctaRef} className="wt-cta">
        <button className="wt-btn" onClick={() => navigate("/course")}>
          Explore Courses
          <span className="wt-btn-arrow">→</span>
        </button>
      </div>

      {/* Scroll indicator */}
      <div ref={scrollRef} className="wt-scroll">
        <div className="wt-scroll-track">
          <div className="wt-scroll-dot" />
        </div>
        <span className="wt-scroll-label">Scroll</span>
      </div>

    </section>
  );
}